import { connect } from "react-redux";
import { fetchPermissionDetails } from "@actions/1_entities/account_actions";
import Permissions from './permissions'

const mapStateToProps = (state) =>({})
const mapDispatchToProps = (dispatch) => ({
  fetchPermissionDetails: (success, error)=> dispatch(fetchPermissionDetails(success, error))
});

export default connect(mapStateToProps, mapDispatchToProps)(Permissions)